import TransactionAnalytics from './TransactionAnalytics';
export default function GSTAnalytics() { return <TransactionAnalytics kind="gst-analytics" title="GST Analytics"/>; }
